export default "__VITE_ASSET__CXixJagF__"